module.exports = __webpack_public_path__ + "static/media/food-fraud-sq.b272fd40.jpg";